import { JsonObject, JsonProperty } from 'json2typescript';
import AggregatorModel from './AggregatorModel';

@JsonObject('RentalSearchModel')
export default class RentalSearchModel {
  @JsonProperty('aggregator', AggregatorModel) public aggregator:AggregatorModel = undefined;
  @JsonProperty('dep_name', String) public depStationName:string = '';
  @JsonProperty('arr_name', String) public arrStationName:string = '';
}
